import BaseViewModel, { BaseViewModelParams } from './BaseViewModel';
import { GarDataModel } from 'src/Modules/Gar/GarDataModel';
import { GarAddressType } from 'src/Modules/Gar';

class FiasRegionSelectControlViewModel extends BaseViewModel {
	typeId = 'FiasRegionSelectControlViewModel';
	FiasComponentVisibility = '-:';
	FiasComponentMandatory = '!:';

	inited = false;

	data: GarDataModel | null = null;
	isNeedUpdate?: (gar: GarDataModel | null) => void;

	constructor(params: BaseViewModelParams) {
		super(params);
		this.data = new GarDataModel(this.ControlKey);
		this.inited = true;
	}

	updateOwner = () => {
		if (this.isNeedUpdate) {
			this.isNeedUpdate(this.data);
		}
	};

	runValidation = (): boolean => {
		if (BaseViewModel.isClientScripts) {
			if (!this.data) {
				throw new Error('Данные ГАР не инициализированы');
			}
			if (this.data.validationEnabled) {
				const isValid = this.data.isValid();
				this.updateOwner();
				return isValid;
			}
		}
		return true;
	};

	updateValue = (entity: GarAddressType | null, needCheck = true) => {
		const isEqual = JSON.stringify(entity) === JSON.stringify(this.Value);
		console.log('updateValue', entity, needCheck, isEqual);
		if (needCheck) {
			if (isEqual) {
				return;
			}
		}
		this.setValue(entity);
	};

	// Строковое представление адреса для simpleformat
	valueToString = () => {
		if (!this.Value) {
			return '';
		}
		return this.data?.valueToString();
	};
}

export default FiasRegionSelectControlViewModel;
